import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'plural'
})
export class PluralPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    if (value.endsWith('s')) {
      return value;
    }
    else if (value.endsWith('y')) {
      let length = value.length;
      if (['a', 'e', 'i', 'o', 'u'].includes(value[length - 2].toLowerCase())) {
        return value + 's';
      } else {
        return value.slice(0, length - 1) + 'ies'
      }
    } else {
      return value + 's';
    }
  }

}
